import { render, staticRenderFns } from "./BookingCompanyContact.vue?vue&type=template&id=53ecc0a0"
import script from "./BookingCompanyContact.vue?vue&type=script&lang=js"
export * from "./BookingCompanyContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports